module.exports = __webpack_public_path__ + "img/92.841677a9.jpg";